import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function CollapsibleCard({ title, icon: Icon, defaultOpen = false, testId, children, className = "", maxWidthClass = "max-w-2xl" }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Card className={`mt-6 ${maxWidthClass} overflow-hidden border-slate-200 shadow-sm ${className}`} data-testid={testId}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-2 p-6 text-left transition-colors hover:bg-slate-50"
        data-testid={testId ? `${testId}-toggle` : undefined} aria-expanded={open}>
        {Icon && <Icon className="h-5 w-5 shrink-0 text-slate-400" />}
        <h3 className="text-lg font-semibold text-slate-800 font-heading">{title}</h3>
        <ChevronDown className={`ml-auto h-5 w-5 shrink-0 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="-mt-1 px-6 pb-6">{children}</div>}
    </Card>
  );
}
